export const ANALYTICS_EVENTS = {
  SUBMIT_FEEDBACK_FORM: 'submit_form685924108',
};
